import React from "react";

import { Pill, PillVariants } from "src/design-system/Pill";

export type ValueWithColor = {
  value: string;
  color?: string | null;
  display_name?: string | null;
  displayName?: string | null;
};

type TagPillProps = {
  value: ValueWithColor | string;
  size?: "sm" | "md";
};

export const TagPill: React.FC<TagPillProps> = ({ value, size = "sm" }) => {
  const displayValue =
    typeof value === "string"
      ? value
      : value.display_name || value.displayName || value.value;
  const color = typeof value === "object" && value.color ? value.color : "gray";

  return (
    <Pill size={size} variant={color as PillVariants}>
      <Pill.Text>{displayValue}</Pill.Text>
    </Pill>
  );
};
